import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import AuthLogin from '@containers/AuthLogin';
import EasyAccess from '@containers/EasyAccess';
import AuthenticatedComponents from './AuthenticatedComponents';
import { useUser } from '@utils/contexts';
import PrivacyTerms from '../containers/PrivacyTerms/LoggedOut';
import GoogleLogin from '@containers/GoogleLogin';
import UploadMN from '@containers/UploadMN';

const MyRouter = () => {
  const { hasUser } = useUser();
  return (
    <Switch>
      <Route path="/Upload" render={(props) => <UploadMN {...props} />} />
      <Route path="/GoogleLogin" render={(props) => <GoogleLogin {...props} />} />
      <Route path="/EasyAccess" render={(props) => <EasyAccess {...props} />} />
      <Route path="/AuthLogin" render={(props) => <AuthLogin {...props} />} />
      <Route path="/PrivacyTerms" render={(props) => <PrivacyTerms {...props} />} />
      {hasUser() ? <AuthenticatedComponents /> : <Redirect to="/AuthLogin" />}
    </Switch>
  );
};

export default withRouter(MyRouter);
